import { defineComponent as _defineComponent } from 'vue'
import CallToAction from '@/features/global-home/components/CallToAction.vue';
import GlobalCards from '@/features/global-home/components/card/GlobalCards.vue';
import GlobalHero from '@/features/global-home/components/GlobalHero.vue';
import GlobalLargeSpotlight from '@/features/global-home/components/GlobalLargeSpotlight.vue';
import GlobalProviderSpotlight from '@/features/global-home/components/GlobalProviderSpotlight.vue';
import GlobalSmallSpotlight from '@/features/global-home/components/GlobalSmallSpotlight.vue';
import GlobalTitles from '@/features/global-home/components/GlobalTitles.vue';

import CountriesList from '@/components/countries-list/CountriesList.vue';

import { COUNTRY_EXCEPTIONS } from '@/constants/web-locales.constant';

import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useConstantStore } from '@/stores/pinia/useConstantStore';

import { ObjectType } from '@/@types/graphql-types';
import { isSportSupported } from '@/features/sports/types/enums';

import { computed } from 'vue';

import UKHomeHero from '@/components/experiments/UKHomeExp2/UKHomeHero.vue';
import UKHomeTop10Titles from '@/components/experiments/UKHomeExp2/UKHomeTop10Titles.vue';
import { useActivateExperiment } from '@/libraries/experiment';

export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHome',
  setup(__props) {

const GlobalSports = () =>
	import(/* webpackChunkName: "spotlight-sport" */ '@/features/global-home/components/sports/GlobalSports.vue');

// Hardcoded value for now @liam.best
const spotlightProvider = { shortName: 'atp' };

const logoSrc = `/${ASSETS_DIR}/img/home/logo.svg`;

const { providersByShortName } = storeToRefs(useConstantStore());
const { country, language, webLocale } = storeToRefs(useLanguageStore());

const hasSports = computed(() => {
	const isException = COUNTRY_EXCEPTIONS[webLocale.value];
	if (isException) {
		return isSportSupported(isException);
	}

	return isSportSupported(webLocale.value);
});

// EXP_UK_HOME_2
const activateUkHomeExp = computed(() => country.value === 'GB');
const { activeVariant: ukHomeActiveVariant } = useActivateExperiment('EXP_UK_HOME_2', activateUkHomeExp);
const showUkHomeExpComponents = computed(
	() => ukHomeActiveVariant.value === 'variant_1' || ukHomeActiveVariant.value === 'variant_2'
);
// EXP_UK_HOME_2

return { __sfc: true,GlobalSports, spotlightProvider, logoSrc, providersByShortName, country, language, webLocale, hasSports, activateUkHomeExp, ukHomeActiveVariant, showUkHomeExpComponents, CallToAction, GlobalCards, GlobalHero, GlobalLargeSpotlight, GlobalProviderSpotlight, GlobalSmallSpotlight, GlobalTitles, CountriesList, ObjectType, UKHomeHero, UKHomeTop10Titles }
}

})